import { render, staticRenderFns } from "./TotalLogin.vue?vue&type=template&id=05382206&scoped=true&"
import script from "./TotalLogin.vue?vue&type=script&lang=js&"
export * from "./TotalLogin.vue?vue&type=script&lang=js&"
import style0 from "./TotalLogin.vue?vue&type=style&index=0&id=05382206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05382206",
  null
  
)

export default component.exports